import type { ApiError } from '@approvalmax/types';

export const isApiError = (error?: Error): error is ApiError => {
    return error instanceof Error && 'title' in error && 'detail' in error && 'status' in error && 'code' in error;
};
